import React from 'react'
import { useTranslation } from 'react-i18next'
import { Switch, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import Header from './common/header/ResponsiveHeader'
import { usePermissions } from './common/permission/usePermissions'
import { ProtectedRoute } from './common/ProtectedRoute'
import EditEndorsementKeyPage from './EndorsementKeys/EditEndorsementKeyPage'
import EndorsementKeysPage from './EndorsementKeys/EndorsementKeysPage'
import { EntraIdRolesPage } from './entraIdRoles/entraIdRolesPage'
import EditKeyMappingPage from './KeyMappings/EditKeyMappingPage'
import KeyMappingsPage from './KeyMappings/KeyMappingsPage'
import { EditKeyPage } from './keys/EditKeyPage'
import { ManageKeysPage } from './keys/ManageKeysPage'
import EditSigningKeyPage from './SigningKeys/EditSigningKeyPage'
import SigningKeysPage from './SigningKeys/SigningKeysPage'
import UnlockPinPage from './unLockPin/UnlockPinPage'
import EditUsagePermissionPage from './usagePermissions/EditUsagePermissionsPage'
import UsagePermissionsPage from './usagePermissions/UsagePermissionsPage'
import PageNotFound from './PageNotFound'
import UnauthorizedAccessPage from './UnauthorizedAccessPage'

import 'react-toastify/dist/ReactToastify.css'

export const App = () => {
  const { t } = useTranslation()

  const {
    permissionsForKeysPages,
    permissionsForPermissionsPage,
    permissionsForEntraIdRolesPage,
  } = usePermissions()

  const location = useLocation<any>()
  const isModal = location.state && location.state.parent

  function ErrorFallback({ error, resetErrorBoundary }) {
    return (
      <div role="alert">
        <p>{t('something_went_wrong')}</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>{t('try_again')}</button>
      </div>
    )
  }

  return (
    <div>
      <Header />
      <Switch location={isModal || location}>
        <ProtectedRoute
          exact
          path="/"
          component={ManageKeysPage}
          requiredPermissions={permissionsForKeysPages}
          isHomeComponent={true}
        />
        <ProtectedRoute
          path="/keys"
          component={ManageKeysPage}
          requiredPermissions={permissionsForKeysPages}
          isHomeComponent={true}
        />
        <ProtectedRoute
          path="/keymappings"
          component={KeyMappingsPage}
          requiredPermissions={permissionsForPermissionsPage}
        />
        <ProtectedRoute
          path="/signingkeys"
          component={SigningKeysPage}
          requiredPermissions={permissionsForKeysPages}
        />
        <ProtectedRoute
          path="/usagepermissions"
          component={UsagePermissionsPage}
          requiredPermissions={permissionsForPermissionsPage}
        />
        <ProtectedRoute
          path="/endorsementKeys"
          component={EndorsementKeysPage}
          requiredPermissions={permissionsForKeysPages}
        />
        <ProtectedRoute
          path="/entraidroles"
          component={EntraIdRolesPage}
          requiredPermissions={permissionsForEntraIdRolesPage}
        />
        <ProtectedRoute path="/unlock-pin" component={UnlockPinPage} />
        <ProtectedRoute
          path="/unauthorized"
          component={UnauthorizedAccessPage}
        />
        <ProtectedRoute component={PageNotFound} />
      </Switch>
      {isModal && (
        <>
          <ProtectedRoute
            exact
            path="/keys/:slug"
            component={EditKeyPage}
            requiredPermissions={permissionsForKeysPages}
          />
          <ProtectedRoute
            exact
            path="/keymappings/:slug"
            component={EditKeyMappingPage}
            requiredPermissions={permissionsForPermissionsPage}
          />
          <ProtectedRoute
            exact
            path="/usagepermissions/:slug"
            component={EditUsagePermissionPage}
            requiredPermissions={permissionsForPermissionsPage}
          />
          <ProtectedRoute
            exact
            path="/signingkeys/:slug"
            component={EditSigningKeyPage}
            requiredPermissions={permissionsForKeysPages}
          />
          <ProtectedRoute
            exact
            path="/endorsementkeys/:slug"
            component={EditEndorsementKeyPage}
            requiredPermissions={permissionsForKeysPages}
          />
        </>
      )}
      <ToastContainer autoClose={3000} hideProgressBar theme="colored" />
    </div>
  )
}
